// src/components/ExamNavigateModal.jsx
// Jump-to-any-question control, reachable from the split-screen's Navigate button.

import React from 'react';
import { X, CheckCircle, Circle, Flag } from 'lucide-react';

function plainTextWordCount(html) {
  const text = (html || '').replace(/<[^>]*>/g, ' ').trim();
  return text ? text.split(/\s+/).length : 0;
}

const ExamNavigateModal = ({ groups, answers, currentGroupId, onSelect, onClose }) => {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: 'white', borderRadius: '12px', padding: '20px', width: '360px', maxHeight: '80vh', overflowY: 'auto' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ margin: 0, color: '#2c3e50' }}>Jump to Question</h3>
          <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#718096' }}>
            <X size={20} />
          </button>
        </div>

        {groups.map(group => {
          const answer = answers[group.id];
          const hasContent = plainTextWordCount(answer?.wordProcessor?.html) > 0;
          const isActive = group.id === currentGroupId;
          return (
            <button
              key={group.id}
              type="button"
              onClick={() => onSelect(group.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px', width: '100%',
                padding: '12px', marginBottom: '6px',
                background: isActive ? '#c33329' : '#f4f6f9',
                color: isActive ? 'white' : '#2c3e50',
                border: 'none', borderRadius: '8px', cursor: 'pointer', textAlign: 'left', fontSize: '14px'
              }}
            >
              {hasContent
                ? <CheckCircle size={15} color={isActive ? 'white' : '#1b998b'} />
                : <Circle size={15} color={isActive ? 'white' : '#cbd5e0'} />}
              <span style={{ flex: 1, fontWeight: '600' }}>{group.name}</span>
              {answer?.flagged && <Flag size={13} color={isActive ? 'white' : '#e74c3c'} fill={isActive ? 'white' : '#e74c3c'} />}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ExamNavigateModal;
